/* eslint-disable eqeqeq */
import style from "./CsvImport.module.css";
import gStyle from "../../css/GeneralStyle.module.css";
import React, { useState, useEffect } from "react";
import jwtDefaultConfig from "../../auth/jwt/jwtDefaultConfig";
import "react-toastify/dist/ReactToastify.css";
import ClipLoader from "react-spinners/ClipLoader";
import { ToastContainer, toast } from "react-toastify";

import CsvImportDataCheckComponent from "../../components/common/CsvImportDataCheckInput.tsx";

const CarrierImport = () => {

  const [importErrorData, setImportErrorData] = useState([]);
  const [loadFlag, setLoadFlag] = useState(false);

  let carrierCsvHeader = [
    "運送業者ｺｰﾄﾞ",
    "運送業者名",
    "郵便番号",
    "住所1",
    "住所2",
    "運送業者略称",
    "ﾌﾘｶﾞﾅ",
    "電話番号",
    "FAX番号",
    "ﾒｰﾙｱﾄﾞﾚｽ",
  ];

  useEffect(() => {
    if (importErrorData[0] == "success" && loadFlag == false) {
      toast.success("インポート致しました。", { autoClose: 3000 });
      setImportErrorData([])
    }
    csLoading(loadFlag);
  }, [loadFlag, importErrorData]);

  const csLoading = (flag) => {
    if (flag) {
      document.getElementById("csLoader").style.display = "flex";
    } else {
      document.getElementById("csLoader").style.display = "none";
    }
  };

  return (
    <div className={gStyle.display}>
      <div className={gStyle.loader_container} id="csLoader">
        <ClipLoader color={"#fff"} size={60} />
      </div>
      <ToastContainer />
      <div className={gStyle.border}>
        <p className={gStyle.text}>運送業者CSVインポート</p>
      </div>
      <div className={gStyle.filed}>
        <div className={style.cs_card}>
          <CsvImportDataCheckComponent
            url={jwtDefaultConfig.importCarrierCsv}
            setErrorData={setImportErrorData}
            setLoadFlag={setLoadFlag}
            csvHeader={carrierCsvHeader}
            index={1}
          />
          <div className={style.error_tag}>
            {importErrorData?.map((value, index) => (
              value != 'success' &&
              <p className={style.error_content} key={index}>{value}</p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarrierImport;
